import { AutogenLayoutConfirmOrderSave } from "./autogen/AutogenLayoutConfirmOrderSave";

export class ConfirmOrderSave extends AutogenLayoutConfirmOrderSave {
}
